import { useSyncExternalStore } from 'react'

export type Layout = 'phone' | 'tablet' | 'desktop'

// Tailwind's sm and lg, so a component's own classes and the layout it is
// placed in change at the same widths.
const phone = '(max-width: 639.98px)'
const desktop = '(min-width: 1024px)'

function read(): Layout {
  if (typeof window.matchMedia !== 'function') return 'desktop'
  if (window.matchMedia(phone).matches) return 'phone'
  return window.matchMedia(desktop).matches ? 'desktop' : 'tablet'
}

function subscribe(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => {}
  const lists = [window.matchMedia(phone), window.matchMedia(desktop)]
  for (const l of lists) l.addEventListener('change', onChange)
  return () => { for (const l of lists) l.removeEventListener('change', onChange) }
}

// useLayout is which of the three layouts the window is wide enough for:
// under 640px a phone's, under 1024px a tablet's, otherwise the desktop's.
export function useLayout(): Layout {
  return useSyncExternalStore(subscribe, read)
}
